module.exports = __webpack_public_path__ + "media/packs/site/assets/images/background-8dd5117e6d10f43d8a2a8c7319720da9.png";